<template>
<div class="login">
  <div class='page'>
    <h1>Login</h1>
    <form class='form' @submit.prevent="submit">
      <p>
        <label for="email">Email</label>
        <input v-model="email" type="text" id='email' required />
      </p>
      <p>
        <label for='password'>Password</label>
        <input v-model="password" type="password" id='password' required />
      </p>
      <p v-if="error" class='error'>{{error}}</p>
      <div class='actions'>
        <button>Login</button>
      </div>
    </form>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'login',
    data: function() {
        return {
            email: "",
            password: "",
            error: ""
        }
    },
    methods: {
        submit: function() {
            let self = this
            self.error = ""
            this.rpc("rest", "User", "login", {username:this.email, password:this.password}, "Logging In")
                .then(function(data) {
                    console.log(data)
                    self.$store.commit("setUser", data)
                })
                .catch(function(error) {
                    self.error=error.result
                })
        }
    },
    components: {
    }
}
</script>

<style scoped>
.login {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: #eee;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}
.page {
    padding: 20px;
    background-color: white;
    text-align: left;
    border-radius: 5px;
    width: 300px;
}
.form label {
    display: block;
}
</style>
